import { useQuery } from '@hooks/reactQuery';

import { getApprovalInfo } from '@api/assetsRent';

import { isNotEmpty } from '@utils/common';

import { IAssetRentRequestCardApproveItem } from '@interfaces/rent/assetRent';

import { APPROVAL_UNIT_INFO } from '@constants/queryKeys';

interface IUseFetchApprovalInfoProps {
	assetId: string;
	isAO: boolean;
	searchValue: string;
	isAssetItemsLoading?: boolean;
	isAssetShownOnMap?: boolean;
}

interface IUseAssetRentApprovalUnitInfo {
	approvalInfoItems: Array<IAssetRentRequestCardApproveItem>;
	isLoadingApprovalInfo: boolean;
	refetchApprovalInfo: () => void;
}

export const useQueryApprovalInfo = ({
	assetId,
	isAO,
	searchValue,
	isAssetItemsLoading,
	isAssetShownOnMap = true,
}: IUseFetchApprovalInfoProps): IUseAssetRentApprovalUnitInfo => {
	const {
		data: approvalInfoItems,
		refetch: refetchApprovalInfo,
		isFetching,
	} = useQuery({
		queryKey: [
			APPROVAL_UNIT_INFO,
			assetId,
			isAO,
		],
		queryFn: () => {
			return getApprovalInfo(isAO, {
				itemId: assetId,
			});
		},
		refetchOnWindowFocus: false,
		enabled: [!isAssetItemsLoading, assetId, isAssetShownOnMap],
	});

	const filteredItems = isNotEmpty<IAssetRentRequestCardApproveItem[]>(approvalInfoItems)
		? approvalInfoItems.filter((item: IAssetRentRequestCardApproveItem) => {
			if (!searchValue) return true;

			return item.approvalUnit.users.some((user) => {
				return user?.firstName.toLowerCase().includes(searchValue.toLowerCase())
					|| user?.lastName.toLowerCase().includes(searchValue.toLowerCase());
			});
		})
		: [];

	return {
		isLoadingApprovalInfo: isFetching,
		approvalInfoItems: filteredItems,
		refetchApprovalInfo,
	};
};
